import { createAction } from '@reduxjs/toolkit';

export const toggleMenu = createAction('app/toggleMenu');
export const addLoading = createAction('app/addLoading');
export const removeLoading = createAction('app/removeLoading');
export const showError = createAction<ShowAlertPayload>('app/showError');
export const showSuccess = createAction<ShowAlertPayload>('app/showSuccess');
export const hideAlert = createAction('app/hideAlert');
export const showConfirm = createAction<ShowConfirmPayload>('app/showConfirm');
export const hideConfirm = createAction('app/hideConfirm');
